import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { UpdateBanner } from './components/UpdateBanner';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    {/* 有新版本的提示条 —— 挂在最外层,登录页、改密码页也要看得到 */}
    <UpdateBanner />
  </StrictMode>,
);
